<script>
import validate from '@/mixins/validate';
export default {
    name: 'Edit',
    mixins: [validate],
    props: {
        value: {
            type: [String, Number, Boolean, Object, Array, Function, Date, File],
            default: null
        },
        testId: {
            type: String,
            default: null
        },
        options: {
            type: [Object, Function],
            default: () => {}
        },
        form: {
            type: Boolean,
            default: false
        },
        label: {
            type: String,
            default: null
        },
        hint: {
            type: String,
            default: null
        },
        description: {
            type: String,
            default: null
        },
        placeholder: {
            type: String,
            default: null
        },
        rules: {
            type: Array,
            default: () => []
        },
        error: {
            type: Boolean,
            default: false
        },
        errorMessages: {
            type: Array,
            default: () => []
        },
        mask: {
            type: [Object, Function],
            default: null
        },
        required: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        readonly: {
            type: Boolean,
            default: false
        },
        autocomplete: {
            type: Boolean,
            default: true
        },
        reverse: {
            type: Boolean,
            default: false
        },
        outlined: {
            type: Boolean,
            default: true
        },
        singleLine: {
            type: Boolean,
            default: false
        },
        hideDetails: {
            type: Boolean,
            default: null
        },
        hideLabel: {
            type: Boolean,
            default: false
        },
        hidePlaceholder: {
            type: Boolean,
            default: false
        },
        rounded: {
            type: Boolean,
            default: false
        },
        name: {
            type: String,
            default: null
        },
        prefix: {
            type: String,
            default: ''
        },
        suffix: {
            type: String,
            default: ''
        },
        info: {
            type: String,
            default: null
        },
        clearable: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        inputValue: {
            get() {
                return this.value;
            },
            set(v) {
                this.$emit('input', v);
            }
        },
        optionsConfig() {
            if (this._.isFunction(this.options)) {
                return this.options(this.value);
            }
            if (this._.isObject(this.options)) {
                return this.options;
            }
            return {};
        },
        maskValue() {
            if (this._.isFunction(this.mask)) {
                return this.mask(this.value);
            }

            if (this._.isPlainObject(this.mask)) {
                return { ...this.mask, prefix: this.prefixValue, suffix: this.suffixValue, placeholder: ' ' };
            }

            return null;
        },
        validators() {
            let validators = [];

            if (this.required) {
                validators.push(() => this.getValidator('required')(this.inputValue, this.label));
            }

            if (this.rules && Array.isArray(this.rules)) {
                validators.push(...this.rules);
            }

            return validators;
        },
        isValid() {
            if (this.errorMessages.length) {
                return false;
            }

            if (
                this.isMounted &&
                this._.has(this.$refs, 'input.valid') &&
                this.$refs['input'].shouldValidate &&
                !this.$refs['input'].valid
            ) {
                return false;
            }

            if (
                this.isMounted &&
                this._.has(this.$refs, 'input-error.valid') &&
                this.$refs['input-error'].shouldValidate &&
                !this.$refs['input-error'].valid
            ) {
                return false;
            }

            return true;
        },
        classList() {
            const name = this._.snakeCase(this.$options.name).replace('_', '__');

            let classList = [name];

            if (this.form) {
                classList.push(`${name}--form`);
            }

            if (this.label) {
                classList.push(`${name}--label`);
            }

            if (this.hint) {
                classList.push(`${name}--hint`);
            }

            if (this.description) {
                classList.push(`${name}--description`);
            }

            if (this.required) {
                classList.push(`${name}--required`);
            }

            if (this.disabled) {
                classList.push(`${name}--disabled`);
            }

            if (this.readonly) {
                classList.push(`${name}--readonly`);
            }

            if (!this.isValid) {
                classList.push(`${name}--error`);
            }

            return classList.join(' ');
        },
        prefixValue() {
            return this.prefix;
        },
        suffixValue() {
            return this.suffix;
        }
    },
    methods: {
        getOption(key, defaultValue = false) {
            return this._.has(this.optionsConfig, key) ? this.optionsConfig[`${key}`] : defaultValue;
        }
    },
    render: () => ({})
};
</script>

<style lang="scss">
div[class^='edit__'] {
    .v-input .v-input__append-inner,
    .v-input .v-input__prepend-inner {
        .v-input {
            margin-top: 0;
        }
        div[class^='edit__'] {
            min-width: 0;
            .v-input__slot {
                padding: 0;
            }
            input {
                font-size: 1rem;
                padding-top: 0;
                padding-bottom: 0;
                text-align: right;
            }
        }
    }
}
</style>
